import store from "../../Redux/store";
import { setStats } from "./Dashboard.reducer";

export function saveStats(records) {
  store.dispatch(setStats(records));
}
